export default function (injection, Vue) {
    const alias = {
        ok (message, content) {
            injection.notify.normalNotify({tpl: 'success', text: message, content});
        },
        error (message, content) {
            injection.notify.normalNotify({tpl: 'warn', text: message, content});
        },
        notify: {
            ok (message, content) {
                alias.ok(message, content);
            },
            error (message, content) {
                alias.error(message, content);
            }
        },
        message: {
            ok (message) {
                injection.message.normalMessage({tpl: 'success', text: message});
            },
            error (message) {
                injection.message.normalMessage({tpl: 'warn', text: message});
            }
        }
    };

    Object.defineProperties(injection, {
        alias: {
            get () {
                return alias;
            }
        }
    });

    Object.defineProperties(Vue.prototype, {
        $alias: {
            get () {
                return alias;
            }
        }
    });
}
